import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-modal-popup',
  templateUrl: './modal-popup.component.html',
  styleUrls: ['./modal-popup.component.css']
})
export class ModalPopupComponent implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Output() onCloseModal = new EventEmitter<string>();

  show = false;
  private subscription: Subscription;

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.registerModal(this.id);
    this.subscription = this.modalService.getModalState(this.id).subscribe(open => {
      this.show = open;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  closeModal(): void {
    this.modalService.closeModal(this.id);
    this.onCloseModal.emit(this.id)
  }

}
